// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"form-module--wrapper--1UTQD","button":"form-module--button--3IjjL"};